import React from 'react'
import cn from 'classnames'

import { ReactComponent as Tick } from '../../assets/icons/tick.svg'

import './CheckBox.scss'

export const CheckBox = ({
  label,
  pink,
  blue,
  checked,
  onChange,
}) => {
  return (
    <label className={cn( 'checkbox-container', { pink }, { blue } )}>
      <input
        type="checkbox"
        checked={ checked }
        onChange={ e => onChange(e.target.checked) }
      />
      <div className="box">
        <Tick />
      </div>
      <span>
        { label }
      </span>
    </label>
  )
}